/**
 * Loads the build id that the pipeline writes into `build.json` (`<version>-<commit>`, for example
 * `2.18.1-dev-a1b2c3d4`; see `tools/generate-version-json.mjs`).
 *
 * The file is always requested with `cache: 'no-store'`: it is the source of the build id, so it cannot
 * be stamped with its own value, and the CDN serves it with a one-year `Cache-Control`.
 *
 * Any failure (missing file, for example in `npm start`, or an unexpected body) resolves to `undefined`
 * and the caller falls back to the app version, so the app never waits on or fails because of this file.
 */
export async function loadBuildId(): Promise<string | undefined> {
  try {
    const response = await fetch('/build.json', { cache: 'no-store' });
    if (!response.ok) {
      return undefined;
    }
    const { buildId } = (await response.json()) as { buildId?: unknown };
    return typeof buildId === 'string' && buildId.trim() ? buildId.trim() : undefined;
  } catch {
    return undefined;
  }
}
